import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import DiscourseItemVersionHistory from './DiscourseItemVersionHistory';
import { Size } from '../../../../Enums/Size.enum';
import { DiscourseBaseItem } from '../DiscourseHistory/DiscourseHistoryItem';

interface Props extends DiscourseBaseItem, BaseModalProps {
	discourseId: string;
}

const DiscourseItemVersionHistoryModal: React.FC<Props> = props => (
	<BaseModal {...props} title='base.versionHistory' size={Size.LG}>
		<DiscourseItemVersionHistory
			discourseId={props.discourseId}
			patientId={props.patientId}
			virtualPatientId={props.virtualPatientId}
			openCareClaimModal={props.openCareClaimModal}
			reloadData={props.reloadData}
		/>
	</BaseModal>
);

export default DiscourseItemVersionHistoryModal;
